<script>

    import { createEventDispatcher } from 'svelte';
    import Modal from "../UI/Modal.svelte";
    import Button from "../UI/Button.svelte";

    const dispatch = createEventDispatcher()
        
    function cancelModal() {
        dispatch('cancel')
    }
    export let plantName;
    var title =`Harvest your ${plantName} Plants`

    </script>

    
    <Modal title={title} on:cancel>  
        <p>How do you know that your vegetables are ready for harvest?</p>
        <div slot="footer">
            <Button 
            mode= "outline" 
            type= "button" 
            on:click={cancelModal}>
            
            back</Button>
        </div>
    </Modal>